<template>
    <div class="animated fadeIn">
        <b-card header-tag="header">
            <div slot="header">
                <i class="cui-calendar"></i> Links de Pagamento
                <b-link :to="`/${actionUri}/new/`" class="btn mr-2 btn-sm btn-primary float-right">
                <i class="fa fa-plus"></i>
                  Entrada
                </b-link>
            </div>
            <b-card-body>
                <div class="form-row justift-content-start">
                  <template v-if="$auth.isPartner">
                    <div class="col-md-3">
                      <div class="form-group">
                        <label>Empresa</label>
                        <model-list-select
                          v-if="$auth.isPartner"
                          :list="sellers.data"
                          option-value="id"
                          option-text="name"
                          v-model="sellers.selected"
                          placeholder="Digite o nome da empresa"
                          @searchchange="searchSellers"
                        ></model-list-select>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-group">
                        <label>Nome do link</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="keywords"
                        />
                      </div>
                    </div>
                  </template>                  
                </div>
                <b-row>
                  <b-col md="6" class="my-1">
                    <b-form-group label-cols-sm="0" label="" class="mb-0">
                      <b-input-group>
                        <b-input-group-append>
                          <b-button @click="search" variant="primary">Buscar</b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>                 
            </b-card-body>
        </b-card>
        <b-card>
          <c-table @onPageIndexChanged="onPageIndexChanged" :table-data="result" :actionUri="actionUri" :loading="loading" :fields="fields" @onCustomActionClick="onCustomActionClick" striped></c-table>
        </b-card>
        <b-modal
          id="modal-remove"
          ref="removeModal"
          title="Remover Link"
          @hidden="resetRemoveModal"
          @ok="handleRemoveModalOk"
          ok-title="Remover"
          cancel-title="Cancelar"
          v-model="removeModalVisible">
          <div class="alert alert-danger" role="alert" v-show="removeModel.hasError">{{removeModel.errorMessage}}</div>
          <form ref="form" @submit.stop.prevent="handleRemoveSubmit">
            <div class="form-row">
              <div class="col-sm-12">
                Você tem certeza que deseja remover o link {{removeModel.name}}?
              </div>
            </div>
          </form>
        </b-modal>
    </div>
</template>
<script>
import { ModelListSelect } from "vue-search-select";
import cTable from '../../../components/base/Table.vue'
import domainService from '../../../services/PaymentLinks/paymentLinkService'
import sellerService from "../../../services/Customer/sellerService";
import listPage from '../../../mixins/listPage';
export default {
  components: {cTable, ModelListSelect},
  mixins: [listPage],
  data() {
    return {
      actionUri: 'partners/paymentLinks',
      fields: [
        {key: 'name', label: 'Nome', sortable: false},
        {key: 'amount', label: 'Valor', sortable: false},
        {key: 'status', label: 'Status', sortable: false},
        {key: 'sellerName', label: 'Empresa', sortable: false},
        {key: 'createdAt', label: 'Criado em', sortable: false},
        {key: 'updatedAt', label: 'Atualizado em', sortable: false},
        {key: 'shortUrl', label: 'Link', sortable: false},
        {key: 'actions', label: ''}
      ],
      removeModel: {
        id: '',
        name: ''
      },
      sellers: {
        selected: null,
        data: [],
        query: "",
      },
    }
  },
  methods: {
    fetchData(page) {
      const self = this      
      self.showLoading()
      domainService.findAll(this.keywords, self.sellers.selected, page).then((response) =>{
          self.$data.result = response.status == 204 ? self.getEmptyResult() : response.data
          self.hideLoading()
      }, () =>{
          self.hideLoading()
      })
    },
    resetRemoveModal() {
      this.removeModel.id = 0
      this.removeModel.name = ''
    },
    handleRemoveSubmit() {
      const self = this
      domainService.remove(self.removeModel.id).then((response) => {
        self.fetchData(1)
        self.$nextTick(() => {
          self.$refs.removeModal.hide()
        })
      },
      (error) => {
        self.removeModel.hasError = true
        self.removeModel.errorMessage = 'Ocorreu um erro na remoção do link de pagamento'
      })
    },
    onCustomActionClick(action, row) {
      switch(action)
      {
        case 'remove':
          this.removeModel.id = row.item.id
          this.removeModel.name = row.item.name
          this.showRemoveModal()
        break
      }
    },    
    searchSellers(newQuery) {
      if (newQuery == null || newQuery.length < 2) return;
      const self = this;
      this.showLoading();
      sellerService.all(newQuery).then(
        (response) => {
          self.sellers.data = response.status == 204 ? [] : response.data;
          self.hideLoading();
        },
        () => {
          self.hideLoading();
        }
      );
    }
  }
}
</script>
